import { createContext, useContext } from "react";
import { Language, dictionaryList, LanguageId } from '../languages';

export interface ILanguageContext {
  language: Language;
  setLanguage: (language: Language) => void;
  dictionary: typeof dictionaryList[Language.English];
  complexity?: Complexity;
  setComplexity: (item: Complexity) => void;
  rateCard?: RateCard;
  setRateCard: (item: RateCard) => void;
  officeId: number;
  setOfficeId: (item: number) => void;
  complexityOverride?: ComplexityOverride;
  setComplexityOverride: (item?: ComplexityOverride) => void;
  rateCardOverride?: RateCardOverride;
  setRateCardOverride: (item?: RateCardOverride) => void;
};

export interface Complexity {
  complexityId: number;
  billingId: number;
  defaultRate: number;
  description: string;
  descriptionFr: string;
};

export interface RateCard {
  rateID: number;
  complexityID: number;
  rate: number;
  isInfoItem: string;
  descrip: string;
  descripFr: string;
};

export interface ComplexityOverride {
  officeId: number;
  billingId: number;
  amount: number;
  rowStatus: string;
};

export interface RateCardOverride {
  officeId: number;
  rateId: number;
  complexityId: number;
  rate: number;
  rowStatus: string;
};

export interface EfileOverride {
  officeId: number;
  craEfileAgentNumber: string;
  craPassword: string;
  mrqAgentNumber: string;
  mrqBusinessNumber: string;
  mrqPassword: string;
  discounterCode: number;
  optionType: string;
  discounterPhoneNumber: string;
  discounterAddress1: string;
  discounterAddress2: string;
  discounterCity: string;
  discounterProvince: string;
  discounterPostalCode: string;
};

export const LanguageContext = createContext<ILanguageContext>({
  language: Language.English,
  setLanguage: () => void 0,
  dictionary: dictionaryList[Language.English],
  complexity: undefined,
  setComplexity: () => void 0,
  rateCard: undefined,
  setRateCard: () => void 0,
  officeId: 0,
  setOfficeId: () => void 0,
  complexityOverride: undefined,
  setComplexityOverride: () => void 0,
  rateCardOverride: undefined,
  setRateCardOverride: () => void 0,
});

export function LanguageText(languageId: LanguageId): string {
  const languageContext = useContext(LanguageContext);

  return languageContext.dictionary[languageId] || languageId;
};
